export default __webpack_public_path__ + "static/media/aboutus_mobile_background.36258512.png";